module.exports = __webpack_public_path__ + "img/vista-3.ccebb4b8.svg";